<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M12 14.4c.6365 0 1.2469-.2529 1.697-.703.4501-.4501.703-1.0605.703-1.697 0-.6365-.2529-1.247-.703-1.6971-.4501-.45007-1.0605-.70292-1.697-.70292-.6366 0-1.247.25285-1.6971.70292-.45008.4501-.70294 1.0606-.70294 1.6971 0 .6365.25286 1.2469.70294 1.697.4501.4501 1.0605.703 1.6971.703Z"
        />
        <path
            fill-rule="evenodd"
            d="M.549561 12C2.07836 7.13158 6.62636 3.59998 12 3.59998c5.3736 0 9.9216 3.5316 11.4504 8.40002-1.5288 4.8684-6.0768 8.4-11.4504 8.4-5.37364 0-9.92164-3.5316-11.450439-8.4ZM16.8 12c0 1.273-.5058 2.4939-1.4059 3.3941C14.4939 16.2943 13.273 16.8 12 16.8c-1.2731 0-2.49398-.5057-3.39415-1.4059C7.70567 14.4939 7.19996 13.273 7.19996 12c0-1.2731.50571-2.49396 1.40589-3.39414C9.50602 7.70569 10.7269 7.19998 12 7.19998c1.273 0 2.4939.50571 3.3941 1.40588C16.2942 9.50604 16.8 10.7269 16.8 12Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 10c-.5304 0-1.0391.2107-1.4142.5858S10 11.4696 10 12c0 .5304.2107 1.0391.5858 1.4142S11.4696 14 12 14c.5304 0 1.0391-.2107 1.4142-.5858S14 12.5304 14 12c0-.5304-.2107-1.0391-.5858-1.4142S12.5304 10 12 10Zm-2.82842-.82843C9.92173 8.42143 10.9391 8 12 8s2.0783.42143 2.8284 1.17157C15.5786 9.92172 16 10.9391 16 12s-.4214 2.0783-1.1716 2.8284C14.0783 15.5786 13.0609 16 12 16c-1.0609 0-2.07827-.4214-2.82842-1.1716-.75015-.7501-1.17157-1.7675-1.17157-2.8284 0-1.0609.42142-2.07828 1.17157-2.82843Z"
            clip-rule="evenodd"
        />
        <path
            fill-rule="evenodd"
            d="M3.51201 12C4.74752 15.4964 8.08323 18 12 18c3.9177 0 7.2525-2.5035 8.488-6C19.2525 8.50354 15.9177 6 12 6c-3.91677 0-7.25248 2.50359-8.48799 6Zm-2.00807-.2996C2.90509 7.23851 7.07378 4 12 4c4.9273 0 9.0949 3.23856 10.4961 7.7004.0612.195.0612.4042 0 .5992C21.0949 16.7614 16.9273 20 12 20c-4.92622 0-9.09491-3.2385-10.49606-7.7004-.06124-.195-.06124-.4042 0-.5992Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
